import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { UserUpdate, getUserByAddress } from '../../hooks/User';
import { ToastContainer, toast } from 'react-toastify';
import { client } from '../../config/ipfsConfig';
import { FiCamera, FiEdit, FiTrash2 } from 'react-icons/fi'; // Camera, Edit, and Trash icons from react-icons
const HeroEditProfile = () => {
  const [user, setUser] = useState({});
  const [isOptionsVisible, setIsOptionsVisible] = useState(false); // Track visibility of options
  const walletAddress = localStorage.getItem('WalletAddress');
  const optionsRef = useRef(null); // Ref for the options container

  useEffect(() => {
    getUser();
  }, [walletAddress]);

  useEffect(() => {
    // Event listener to close options on outside click
    const handleOutsideClick = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setIsOptionsVisible(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const getUser = () => {
    getUserByAddress(walletAddress).then((data) => {
      if (data.status === 200) {
        setUser(data.user);
      }
    });
  };

  const handleChange1 = async (e) => {
    const file = e.target.files[0]; // Get the file from the input
    if (!file) {
      toast.error('No file selected!');
      return;
    }

    try {
      // Upload the file to IPFS
      const added = await client.add(file);
      const url = `https://ipfs.infura.io/ipfs/${added.path}`; // Removed trailing semicolon
      const body = { coverPicture: url };

      // Update the user cover picture
      const response = await UserUpdate(body, user._id);
      if (response.status === 200) {
        getUser(); // Refresh user data
        toast.success('Cover Picture updated successfully!');
      } else {
        toast.error('Failed to update the cover picture.');
        console.error('Error in response:', response);
      }
    } catch (error) {
      toast.error('Error uploading file.');
      console.error('Error uploading file:', error);
    }
  };

  const Getuser = () => {
    getUserByAddress(walletAddress).then((data) => {
      if (data.status === 200) {
        setUser(data.user);
      }
    });
  };

  // Delete Cover Photo
  const DeleteCoverPhoto = async () => {
    try {
      // Default cover photo URL
      const newCoverPicURL = "https://ipfs.infura.io/ipfs/QmTUzVkSaR4LRZeVq6DHpeQcna62zAbfsfUci4fihUtbq2";
      const updateBody = { coverPicture: newCoverPicURL }; // Set coverPicture to default URL

      console.log("updateBody", updateBody);

      // API call to update user data
      const updateResponse = await UserUpdate(updateBody, user._id);
      if (updateResponse.status === 200) {
        toast.success("Cover photo replaced successfully!");
        Getuser(); // Refresh user data to reflect the change
      } else {
        toast.error("Failed to update cover photo.");
      }
    } catch (error) {
      toast.error("Error updating cover photo.");
      console.error("Error:", error);
    }
  };


  const triggerFileInput = () => {
    document.getElementById('imageUpload').click();
  };

  const handleCameraClick = () => {
    setIsOptionsVisible(!isOptionsVisible); // Toggle visibility of options
  };

  return (
    <div className="mb-50">
      <div className="hero__profile">
        <div className="tabs d-flex align-items-center justify-content-between" style={{ width: '95%' }}>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb default mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Edit profile
              </li>
            </ol>
          </nav>
        </div>
        <div
          className="cover"
          style={{
            position: 'relative',
            overflow: 'hidden',
            display: 'block',
          }}
        >
          <img
            src={user.coverPicture ? user.coverPicture : 'img/bg/prrofile.png'}
            alt="cover"
            style={{

              width: '100%',
              // height: 'auto',
              display: 'block',
              transition: 'opacity 0.3s ease',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              right: '0',
              bottom: '0',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <FiCamera
              size={40}
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                color: 'white',
                padding: '10px',
                borderRadius: '50%',
                cursor: 'pointer',
                position: 'absolute',
                bottom: '20px',
                right: '20px',
              }}
              onClick={handleCameraClick} // Show options on camera icon click
            />
            {isOptionsVisible && (
              <div
                ref={optionsRef} // Attach ref to the options container
                style={{
                  position: 'absolute',
                  bottom: '20px',
                  right: '70px',
                  gap: '10px',
                  display: 'flex',
                }}
              >
                <FiEdit
                  size={40}
                  onClick={triggerFileInput}
                  style={{
                    backgroundColor: '#007bff',
                    color: 'white',
                    margin: '0 10px',
                    padding: '10px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                  }}
                />
                <FiTrash2
                  size={40}
                  onClick={DeleteCoverPhoto}
                  style={{
                    backgroundColor: '#dc3545',
                    color: 'white',
                    padding: '10px',
                    borderRadius: '50%',
                    cursor: 'pointer',
                  }}
                />
              </div>
            )}
          </div>
          <input
            id="imageUpload"
            type="file"
            name="cover_photo"
            style={{ display: 'none' }}
            onChange={handleChange1}
            accept="image/*"
          />
        </div>
      </div>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default HeroEditProfile;










